import { Box, styled } from '@mui/material';

export const PageContainer = styled(Box)(({ theme }) => ({
	boxSizing: 'border-box',
	display: 'flex',
	height: '100vh',
	padding: '12px 18px',
	overflow: 'hidden',
	[theme.breakpoints.down('md')]: {
		padding: '8px 12px',
	},
	[theme.breakpoints.down('sm')]: {
		padding: '8px 12px',
	},
	[theme.breakpoints.down('xs')]: {
		padding: '4px 8px',
	},
}));
